module.exports = __webpack_public_path__ + "static/media/fashion-5.10530de5.jpg";